import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Trans } from '@lingui/macro';

// Shared
import Backdrop from '../../../../../../shared/backdropModal';

const modalPortalRoot = document.getElementById('modal-portal-root');

export default class AnonymousModal extends React.Component<
  {
    onContinue: any;
    onCancel: any;
  },
  {}
> {
  el;

  constructor(props) {
    super(props);

    this.el = document.createElement('div');
  }

  componentDidMount = () => {
    modalPortalRoot.appendChild(this.el);
  };

  componentWillUnmount = () => {
    modalPortalRoot.removeChild(this.el);
  };

  render() {
    const content = (
      <Backdrop>
        <div className="pop-up-wrapper">
          <div className="pop-up-container anonymous">
            <h6 className="text-white ml-3">
              <Trans>Se connecter à un employeur</Trans>
            </h6>
            <div className="flex v-align">
              <div className="col v-align align-center text-center">
                <img src="images/icon-anonymous.svg" alt="" className="anonymous-icon" />
                <h3 className="text-white">
                  <Trans>Le respect de votre privée, notre priorité</Trans>
                </h3>
                <p>
                  <Trans>
                    En poursuivant cette connexion, vous acceptez que nous transmettions vos données
                    à cet employeur !
                  </Trans>
                </p>
                <p>
                  <Trans>Voulez-vous continuer ?</Trans>
                </p>
              </div>
            </div>
            <div className="profile-card-buttons-wrapper">
              <div className="profile-card-buttons-cotnainer">
                <a
                  href="#"
                  onClick={this.props.onCancel}
                  className="button outline left-cap grey w-inline-block">
                  <img
                    src="/images/Cancel.svg"
                    width="24"
                    alt=""
                    className="icon-button-profile-card"
                  />
                  &nbsp;<Trans>Annuler</Trans>
                </a>
                <a
                  href="#"
                  onClick={this.props.onContinue}
                  className="button solid right-cap color-accent-1 w-inline-block">
                  <img
                    src="/images/check.svg"
                    width="24"
                    alt=""
                    className="icon-button-profile-card"
                  />
                  &nbsp;<Trans>Continuer</Trans>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Backdrop>
    );

    return ReactDOM.createPortal(content, this.el);
  }
}
